module.exports = __webpack_public_path__ + "static/img/bg-highlights-6.30adb4be.png";